import React from 'react';
import { useSelector } from 'react-redux';
import Course from 'components/prism/course';
import Subheader from 'components/prism/subheader';

export const InProgressCourses = ({ text, data }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);

    return (
        <>
            <Subheader title={text.inprogress} count={data?.length} />
            <div className={prismMultiColumn ? 'even-col' : ''}>
                {data.map(item => (
                    <Course key={`course-${item.id}`} course={item} padBottom={!prismMultiColumn} />
                ))}
            </div>
        </>
    );
};

export default InProgressCourses;
